import React from "react"
import styled, { css } from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import {
  Grid,
  Block,
  Spacer,
} from "../../design-system/atoms/layout-primitives"
import Breakpoints from "../shared/breakpoints"
import ContentBlock from "../../design-system/molecules/content-block"
import Button from "../../design-system/atoms/button"

const ActionImg = styled(Img)`

  @media (min-width: ${Breakpoints.md}) {
    max-height: 250px;
    overflow: hidden; 
  }
`

export default function SeeItInAction() {
  const query = useStaticQuery(graphql`
    query {
      siiaDesktop: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/see it in action desktop.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      siiaMobile: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/see it in action mobile.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      siiaTablet: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/see it in action tablet.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1024, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      <Spacer height={{ sm: "48px", md: "64px", lg: "128px" }} />
      {/* Mapping SDKs */}
      <Grid>
        <Block
          row={{ lg: "1/3" }}
          col={{ sm: "1 / -1", md: "2 / -2", lg: "1 / 6" }}
          align={{ sm: "center", lg: "center" }}
          variants={{
            sm: {
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
            },
          }}
        >
          <ActionImg
            fluid={query.siiaDesktop.childImageSharp.fluid} 
            alt="A laptop displaying Mappedin Developer Tools"
          />
        </Block>
        <Spacer height={{ sm: "32px", md: "48px", lg: "0px" }} />
        <Block
          row={{ lg: "1" }}
          col={{ sm: "1 / -1", md: "2 / -2", lg: "-7 / -2" }}
          align={{ lg: "end" }}
        >
          <ContentBlock.H3
            title="See it in Action"
            description="Provide visitors to your mall or stadium with a seamless and memorable experience using Mappedin's Responsive Web App. Visit the below pages to see how this solution is used in these venues or contact us today to receive a demo of interactive web maps for your industry."
            variants={[null, { textAlign: "center" }, { textAlign: "left" }]}
          />
          <Spacer height={{ sm: "32px", lg: "48px" }} />
        </Block>
        <Block
          row={{ lg: "2" }}
          col={{ sm: "1 / -1", md: "2 / -2", lg: "-7 / -1" }}
          align={{ lg: "start" }}
          display={{ sm: "grid" }}
          variants={{ sm: { gridGap: "24px" } }}
        >
          <Button.Link
            to="https://mappedin.com/industries/malls"
            variants={{
              sm: { padding: "16px 72px", justifySelf: "left" },
              md: { gridRow: "1", justifySelf: "center" },
              lg: { justifySelf: "left" },
            }}
          >
            Shopping Malls
          </Button.Link>
          <Button.Link
            to="https://mappedin.com/industries/stadiums"
            variants={{
              sm: { padding: "16px 56px", justifySelf: "left" },
              md: { gridRow: "1", justifySelf: "center" },
              lg: { justifySelf: "left" },
            }}
          >
            Stadiums & Arenas
          </Button.Link>
        </Block>
      </Grid>
      <Spacer
        height={{ sm: "64px", md: "96px", lg: "128px" }}
        variants={{
          sm: { borderBottom: "1px solid #2e2e2e26" },
          lg: { marginBottom: "32px" },
        }}
      />
    </>
  )
}
